export default "__VITE_ASSET__C6xV_u9m__"